import Service from './abstract';
import _ from 'lodash';
import page from '../constants/pages/page';

const defaultInsurangePlan = 'insurance_plan,insurance_plan.insurance,insurance_plan.insurance.product,status';
const defaultWithProduct = 'insurance_plan.insurance.product.type,insurance_plan.insurance.product.attributes,insurance_plan.insurance.product.attributes.attribute';
const defaultOptions = {
    order: 'created_at-DESC',
    with: `${defaultInsurangePlan},${defaultWithProduct}`,
    pageSize: page.pageSize
};

class Insurances extends Service {
    constructor () {
        super('insurances');
    }

    getRequests (options = {}) {
        return this.get({
            url: `${this.basePath}/requests`,
            qs: _.defaultsDeep(options, defaultOptions)
        }).then(requests => this.normalizeAll(requests));
    }

    normalize (request) {
        if (_.isNil(request)) {
            return request;
        }

        if (request.insurance_plan?.insurance?.product) {
            // Prepare product attributes
            if (request.insurance_plan.insurance.product.attributes) {
                request.insuranceAttributes = _.keyBy(request.insurance_plan.insurance.product.attributes, 'description');
            }
        }

        return request;
    }
}

export default new Insurances();
